import {HiOutlineSparkles} from "react-icons/hi2";

import {Chip, ChipProps, ChipVariant} from "@/components/chip/Chip.tsx";
import {Icon} from "@/components/icon/Icon.tsx";

interface NavBarChipSelectorProps {
  chip: ChipVariant;
  className?: string;
}

export const NavBarChipSelector = ({chip, className}: NavBarChipSelectorProps) => {
  const chipProps: ChipProps = {
    className: className,
    variant: chip,
  };
  switch (chip) {
    case "comingSoon":
      return <Chip {...chipProps}>Coming Soon</Chip>;
    case "beta":
      return <Chip {...chipProps}>Beta</Chip>;
    case "new":
      return (
        <Chip {...chipProps} iconOnly>
          <Icon icon={HiOutlineSparkles} removeDivDimensions />
        </Chip>
      );
    default:
      console.error(`NavBarChipSelector: ${chip} is not a valid chip type`);
      return null;
  }
};
